import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PhysicianService } from '../../physician.service';
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PDFDialogComponent } from "../../../signup-organization/pdf-dialog/pdf-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  constructor(private _userService: UserService, private _physicianService: PhysicianService, private loaderService: WindowLoaderService, public dialog: MatDialog) { }

  ngOnInit() {
    this.getUserDetails();
  }

  setTypeValue(value: number) {
    this.selectedType = value;
  }


  getUserDetails() {
    this.loaderService.show();
    this._userService.getUserDetails().subscribe(
      (result) => {
        this.user = result;
        this.getSubscriptionType();
      },
      (error) => { console.error(error); }
    );
  }

  getSubscriptionType() {
    this._physicianService.getSubscriptionType(this.user.healthOrganizationId).subscribe(
      (result) => {
        this.loaderService.hide();
        this.subscriptionType = result.subType;
      },
      (error) => { console.error(error); }
    )
  }

  updateSubscriptionType() {
    this.loaderService.show();
    this._physicianService.updateSubscriptionType(this.user.healthOrganizationId, this.selectedType).subscribe(
      (result) => {
        this.subscriptionType = this.selectedType;
        this.loaderService.hide();
        document.getElementById("clsModal").click();
      },
      (error) => { console.error(error); }
    )
  }


  openPdfDialog(type: number) {
    let data = {
      title: 'Appy Health Pricing',
      filename: 'AH-Practice-Clinic-Pricing-11-4-2022.pdf',
    }
    if (type === 2) {
      data = {
        title: 'Appy Health Money Back Guarantee',
        filename: 'AH-Money-Back-Guarantee-11.14.2022-D5.pdf',
      }
    } else if (type === 3) {
      data = {
        title: 'Appy Health Cancellation Policy',
        filename: 'AH-Cancellation-Policy-11.14.2022-D9.pdf',
      }
    }

    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
}
